import barClusteredBarChart from "assets/images/chart-images/clustered-bar-chart.png";
import barStachedBar from "assets/images/chart-images/stacked-bar.png";
import table from "assets/images/chart-images/table.png";

const revisionNumberList = [
    { id: "SR#ST-BVS01r", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
    { id: "SR#ST-CC01r", name: "clustered-bar", chartImage: barClusteredBarChart, disabled: false },
    { id: "SR#ST-T01r", name: "table", chartImage: table, v2: "Column", disabled: false },
    { id: "SR#ST-T02r", name: "table", chartImage: table, v2: "Row", disabled: false },
    { id: "SR#ST-T20r", name: "table", chartImage: table, disabled: false },
];

export default revisionNumberList;
